import React from 'react';
import { Redirect, Route, RouteComponentProps, RouteProps } from 'react-router-dom';

import useAuth from 'features/auth/hooks/useAuth';
import { getStartedPaths } from 'features/get-started/routes/paths';

export const PublicRoute: React.FC<RouteProps> = ({ component: Component, render, ...rest }) => {
  const { isLoggedIn } = useAuth();

  const renderComponent = (props: RouteComponentProps) => {
    if (!isLoggedIn) {
      return Component ? <Component {...props} /> : null;
    } else {
      return <Redirect to={getStartedPaths.static.firstStep} />;
    }
  };
  return <Route {...rest} render={render || renderComponent} />;
};
